import types from './mutation-types';
import { SEARCH_PARAMS, CURRENT_MST_VALUE, SEARCH_POPUP_M_PARAMS, SEARCH_POPUP_M_PAGING_INFO, SEARCH_POPUP_D_PARAMS } from './state';

export default {
	[types.SET]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SET_SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SET_SEARCH_POPUP_M_PARAM]: (state, { key, value }) => {
		state.searchPopupMParams[key] = value;
	},
	[types.SET_SEARCH_POPUP_D_PARAM]: (state, { key, value }) => {
		state.searchPopupDParams[key] = value;
	},
	[types.SET_CURRENT_MST_VALUE]: (state, { key, value }) => {
		state.currentMstValue[key] = value;
	},
	[types.SEARCH_POPUP_M_PAGING_INFO]: (state, { key, value }) => {
		state.searchPopupMPagingInfo[key] = value;
	},
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.masterList = [];
		state.detailList = [];
		state.currentMstValue = CURRENT_MST_VALUE();
		state.masterPopupList = [];
		state.detailPopupList = [];
		state.searchPopupMParams = SEARCH_POPUP_M_PARAMS();
		state.searchPopupDParams = SEARCH_POPUP_D_PARAMS();
		state.searchPopupMPagingInfo = SEARCH_POPUP_M_PAGING_INFO();
	},
	[types.STATE_POPUP_INIT]: state => {
		state.masterPopupList = [];
		state.detailPopupList = [];
		state.searchPopupMParams = SEARCH_POPUP_M_PARAMS();
		state.searchPopupDParams = SEARCH_POPUP_D_PARAMS();
		state.searchPopupMPagingInfo = SEARCH_POPUP_M_PAGING_INFO();
	},
	[types.POPUP_DATA_MST_LIST_INIT]: state => {
		state.masterPopupList = [];
	},
	[types.POPUP_DATA_DTL_LIST_INIT]: state => {
		state.detailPopupList = [];
	}
	// [types.SEARCH_PARAM]: (state, { key, value }) => {
	// 	state.searchParams[key] = value;
	// }
};
